import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import TimePicker from 'react-time-picker/dist/entry.nostyle';
import Form from '@piconetworks/pkg-form';
import Icon from '@piconetworks/pkg-icon';
import style from './Time.module.scss.js';

var _excluded = ["className", "dontShowAmPm", "formFieldClassName", "label", "type", "input", "required", "fieldProps"];
var Time = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Time, _React$Component);
  function Time() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      date: null,
      format: 'am'
    };
    _this.onChange = function (time) {
      _this.setState({
        time: time
      });
      _this.props.input.onChange(time);
    };
    return _this;
  }
  var _proto = Time.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var icon;
    var _this$props = this.props,
      className = _this$props.className,
      dontShowAmPm = _this$props.dontShowAmPm,
      formFieldClassName = _this$props.formFieldClassName,
      label = _this$props.label,
      type = _this$props.type,
      input = _this$props.input,
      required = _this$props.required,
      fieldProps = _this$props.fieldProps,
      args = _objectWithoutPropertiesLoose(_this$props, _excluded);
    switch (type) {
      case 'clock':
        icon = /*#__PURE__*/React.createElement(Icon.Default.Clock, {
          height: 24,
          width: 24
        });
        break;
      case 'timer':
        icon = /*#__PURE__*/React.createElement(Icon.Default.Timer, {
          height: 24,
          width: 24
        });
        break;
      default:
        icon = null;
    }
    return /*#__PURE__*/React.createElement(Form.Field, _extends({
      label: label,
      required: required,
      input: input,
      className: formFieldClassName
    }, fieldProps), /*#__PURE__*/React.createElement(TimePicker, _extends({
      clockIcon: icon,
      className: cx(style.timePicker, className),
      onChange: this.onChange,
      value: this.state.date,
      name: input.name
    }, args)), type === 'clock' && !dontShowAmPm && /*#__PURE__*/React.createElement(Form.Dropdown, {
      formFieldClassName: cx(style.dropdownForm),
      options: [{
        label: 'AM',
        value: 'am'
      }, {
        label: 'PM',
        value: 'PM'
      }],
      input: {
        value: this.state.format,
        onChange: function onChange(val) {
          return _this2.setState({
            format: val
          });
        }
      },
      meta: {}
    }));
  };
  return Time;
}(React.Component);
Time.defaultProps = {
  dontShowAmPm: true,
  type: 'clock',
  clearIcon: null
};
Time.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dontShowAmPm: PropTypes.bool,
  fieldProps: PropTypes.object,
  /** This will be deprecated eventually. Instead pass className to the fieldProps */
  formFieldClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  input: PropTypes.object,
  label: PropTypes.node,
  meta: PropTypes.object,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['timer', 'clock', null])
};

export { Time as default };
//# sourceMappingURL=index.js.map
